import { IAuthServiceV2 } from '@volkswagen-onehub/authservice';
import {
	ENDPOINT_ACCEPT_PERSON,
	ENDPOINT_CONSENTS_PERSON,
	ENDPOINT_CREATE_PERSON,
	ENDPOINT_GET_PERSON,
	ENDPOINT_REJECT_PERSON,
} from '../../endpoints';
import { IEsOnehubVWConfig } from '../models/es-one-hub-config';
import { AcceptPerson, ConsentsPerson, CreatePerson } from '../models/portal';

export const getPerson = async (
	authServiceInstance: IAuthServiceV2,
	esOnehubVWConfig: IEsOnehubVWConfig,
): Promise<Response> => {
	const endpoint = ENDPOINT_GET_PERSON;

	const response = await authServiceInstance.get(esOnehubVWConfig.resourceHostId, endpoint, {
		'Content-Type': 'application/json',
	});

	if (!response.ok) {
		throw new Error(`GET request failed with code ${response.status}`);
	}

	return response.json() as Promise<Response>;
};

export const createPerson = async (
	authServiceInstance: IAuthServiceV2,
	esOnehubVWConfig: IEsOnehubVWConfig,
	createPerson: CreatePerson,
): Promise<Response> => {
	const endpoint = ENDPOINT_CREATE_PERSON;

	const response = await authServiceInstance.post(
		esOnehubVWConfig.resourceHostId,
		endpoint,
		JSON.stringify(createPerson),
	);

	if (!response.ok) {
		throw new Error(`GET request failed with code ${response.status}`);
	}

	return response.json() as Promise<Response>;
};

export const acceptPerson = async (
	authServiceInstance: IAuthServiceV2,
	esOnehubVWConfig: IEsOnehubVWConfig,
	acceptPerson: AcceptPerson,
): Promise<Response> => {
	const endpoint = ENDPOINT_ACCEPT_PERSON;
	const response = await authServiceInstance.post(
		esOnehubVWConfig.resourceHostId,
		endpoint,
		JSON.stringify(acceptPerson),
	);

	if (!response.ok) {
		throw new Error(`GET request failed with code ${response.status}`);
	}

	return response.json() as Promise<Response>;
};

export const consentsPerson = async (
	authServiceInstance: IAuthServiceV2,
	esOnehubVWConfig: IEsOnehubVWConfig,
	consentsPerson: ConsentsPerson,
): Promise<Response> => {
	const endpoint = ENDPOINT_CONSENTS_PERSON;
	const response = await authServiceInstance.post(
		esOnehubVWConfig.resourceHostId,
		endpoint,
		JSON.stringify(consentsPerson),
	);

	if (!response.ok) {
		throw new Error(`GET request failed with code ${response.status}`);
	}

	return response.json() as Promise<Response>;
};

export const unsuscribePerson = async (
	authServiceInstance: IAuthServiceV2,
	esOnehubVWConfig: IEsOnehubVWConfig,
): Promise<Response> => {
	const endpoint = ENDPOINT_REJECT_PERSON;
	const response = await authServiceInstance.post(esOnehubVWConfig.resourceHostId, endpoint, undefined);

	if (!response.ok) {
		throw new Error(`GET request failed with code ${response.status}`);
	}

	return response.json() as Promise<Response>;
};
